/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:14
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-07 18:05:31
 * @FilePath: \ioc_base\src\modules\assets\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const routes = [{
  path: '/assetsManage',
  name: 'AssetsManage',
  component: () => import('@src/modules/assets/main'),
  meta: {
    requireAuth: true
  },
  children: [
    {
      path: '/assetsManage/assetsManage',
      name: 'assetsManageIndex',
      component: () => import('@src/modules/assets/view/assetsManage'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    },
    {
      path: '/assetsManage/itemConfig',
      name: 'assetsItemConfig',
      component: () => import('@src/modules/assets/view/itemConfiguration'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    },
    {
      path: '/assetsManage/plan',
      name: 'assetsPlan',
      component: () => import('@src/modules/assets/view/plan'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    },
    {
      path: '/assetsManage/record',
      name: 'assetsRecord',
      component: () => import('@src/modules/assets/view/record'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    },
    {
      path: '/assetsManage/building',
      name: 'assetsBuilding',
      component: () => import('@src/modules/assets/view/building'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    }
  ]
}]

export default routes
